/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import MaterialTable from 'material-table';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
} from '@material-ui/core';
import ExamUpdate from './ExamUpdate';
import useExam from './useExam';

const ExamsList = ({
  examData, companyId, groups, updateExamData, semestersList,
}) => {
  const [modal, setModal] = useState(false);
  const [oldExamData, setOldExamData] = useState({});
  const { deleteExam, updateExam } = useExam(companyId, examData, updateExamData, semestersList, groups);

  // eslint-disable-next-line react/prop-types
  const FormatDate = ({ date, format }) => {
    if (date != null) {
      const formatedDate = moment(date).format(format);
      return <div>{formatedDate}</div>;
    }
    return <div>/</div>;
  };

  const getGap = (date1, date2) => {
    const dateDiff = date2 - date1;
    const diffMins = Math.round(dateDiff / 60 / 1000); // minutes
    let hoursDiff = Math.round((diffMins - (diffMins % 60)) / 60);
    const daysDiff = (hoursDiff - (hoursDiff % 24)) / 24;
    hoursDiff %= 24;
    return `${
      daysDiff > 0 ? `${Math.round(daysDiff)}j ` : ''
    }${hoursDiff >= 1 || diffMins % 60 >= 1 ? `${hoursDiff}h ` : ''}${diffMins % 60 < 10 && diffMins % 60 > 0 ? '0' : ''}${
      diffMins % 60 > 0 ? `${diffMins % 60}min` : ''
    }`;
  };

  return (
    <>
      <MaterialTable
        title="Liste des examens"
        columns={[
          {
            title: 'Examen',
            field: 'examSubject.name',
            render: ({ examSubject }) => {
              if (examSubject && examSubject.name) {
                return examSubject.name;
              }
              return 'Pas de sujet';
            },
          },
          {
            title: 'Semestre',
            field: 'semester',
          },
          {
            title: 'Modalité',
            field: 'modality',
          },
          {
            title: 'Début',
            field: 'examBegin',
            render: ({ examBegin }) => <FormatDate format="DD/MM/YYYY - HH:mm" date={examBegin} />,
            customSort: (a, b) => new Date(a.examBegin) - new Date(b.examBegin),
          },
          {
            title: 'Fin',
            field: 'examEnd',
            render: ({ examEnd }) => <FormatDate format="DD/MM/YYYY - HH:mm" date={examEnd} />,
          },
          {
            title: 'Durée',
            field: 'duration',
            render: ({
              modality, duration, examEnd, examBegin,
            }) => {
              if (!modality.includes('Sur table') && !modality.includes('Oral') && !modality.includes('Dépôt')) {
                if (duration === 60) return '1h';
                if (duration === 90) return '1h30';
                if (duration === 30) return '30min';
                if (duration === 120) return '2h';
              }
              return getGap(moment(examBegin), moment(examEnd));
            },
            customSort: (a, b) => (moment(a.examBegin) - moment(a.examEnd)) - (moment(b.examBegin) - moment(b.examEnd)),
          },
          {
            title: 'EW Corrige',
            field: 'EWCorrect',
            render: (rowData) => {
              if (rowData.EWCorrect === true) {
                if (rowData.deliveryDate) {
                  return <FormatDate date={rowData.deliveryDate} format="Oui - DD/MM" />;
                }
                const tmpDate = new Date(rowData.examEnd);
                tmpDate.setDate(tmpDate.getDate() + 21);
                return <FormatDate date={tmpDate} format="Oui - DD/MM" />;
              }
              return 'Non';
            },
          },
          {
            title: 'Rattrapage',
            field: 'catchUp',
            render: ({ catchUp }) => (catchUp ? 'Oui' : 'Non'),
          },
        ]}
        data={examData}
        style={{
          width: '100%',
          fontSize: '13px',
          color: '#4b4b4b',
        }}
        options={{
          pageSize: 10,
          pageSizeOptions: [5, 10, 20],
        }}
        localization={{
          header: {
            actions: '',
          },
          toolbar: {
            searchPlaceholder: 'Rechercher..',
          },
          body: {
            emptyDataSourceMessage: 'Aucun examen.',
            editRow: {
              deleteText: 'Retirer cet examen ?',
            },
            deleteTooltip: 'Supprimer',
          },
        }}
        actions={[
          {
            icon: 'edit',
            tooltip: 'modifier semestre',
            onClick: (event, rowData) => {
              setOldExamData(rowData);
              setModal(true);
            },
          },
        ]}
        editable={{
          onRowDelete: (oldData) => new Promise((resolve) => {
            deleteExam(oldData).then(() => {
              resolve();
            });
          }),
        }}
      />
      <Dialog
        open={modal}
        onClose={() => setModal(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Mise à jour semestre
        </DialogTitle>
        <DialogContent>
          { oldExamData
            ? (
              <ExamUpdate
                data={oldExamData}
                setModal={setModal}
                closeModal={() => setModal(false)}
                updateExam={updateExam}
                semestersList={semestersList}
              />
            )
            : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModal(false)} color="primary">
            Fermer
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

ExamsList.propTypes = {
  companyId: PropTypes.string.isRequired,
  examData: PropTypes.array.isRequired,
  examBegin: PropTypes.instanceOf(Date).isRequired,
  examEnd: PropTypes.instanceOf(Date).isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  groups: PropTypes.array.isRequired,
  updateExamData: PropTypes.func.isRequired,
  semestersList: PropTypes.array.isRequired,
};

export default ExamsList;
